@file:OptIn(InternalResourceApi::class)

package kinoshazam.resources.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/kinoshazam.resources.generated.resources/"

public val Res.string.about: StringResource by lazy {
      StringResource("string:about", "about", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 896, 21),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1183, 45),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 1463, 45),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 896, 21),
      ))
    }

public val Res.string.about_crawl_body: StringResource by lazy {
      StringResource("string:about_crawl_body", "about_crawl_body", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 177, 344),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 292, 364),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 292, 596),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 177, 344),
      ))
    }

public val Res.string.about_crawl_episode: StringResource by lazy {
      StringResource("string:about_crawl_episode", "about_crawl_episode", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 522, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 657, 43),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 889, 47),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 522, 39),
      ))
    }

public val Res.string.about_crawl_prologue: StringResource by lazy {
      StringResource("string:about_crawl_prologue", "about_crawl_prologue", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 562, 88),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 701, 100),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 937, 136),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 562, 88),
      ))
    }

public val Res.string.about_crawl_title: StringResource by lazy {
      StringResource("string:about_crawl_title", "about_crawl_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 651, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 802, 37),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 1074, 45),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 651, 37),
      ))
    }

public val Res.string.about_text: StringResource by lazy {
      StringResource("string:about_text", "about_text", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 689, 206),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 840, 342),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 1120, 342),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 689, 206),
      ))
    }

public val Res.string.action: StringResource by lazy {
      StringResource("string:action", "action", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 918, 22),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1229, 22),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 1509, 30),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 918, 22),
      ))
    }

public val Res.string.adventures: StringResource by lazy {
      StringResource("string:adventures", "adventures", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 941, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1252, 30),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 1540, 50),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 941, 30),
      ))
    }

public val Res.string.app_copyright: StringResource by lazy {
      StringResource("string:app_copyright", "app_copyright", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 972, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1283, 37),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 1591, 45),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 972, 37),
      ))
    }

public val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1010, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1321, 36),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 1637, 36),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1010, 28),
      ))
    }

public val Res.string.app_version: StringResource by lazy {
      StringResource("string:app_version", "app_version", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1039, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1358, 63),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 1674, 63),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1039, 35),
      ))
    }

public val Res.string.ask_questions: StringResource by lazy {
      StringResource("string:ask_questions", "ask_questions", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1075, 69),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1422, 105),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 1738, 105),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1075, 69),
      ))
    }

public val Res.string.biografy: StringResource by lazy {
      StringResource("string:biografy", "biografy", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1145, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1528, 28),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 1844, 40),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1145, 28),
      ))
    }

public val Res.string.cartoons: StringResource by lazy {
      StringResource("string:cartoons", "cartoons", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1174, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1557, 48),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 1885, 48),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1174, 28),
      ))
    }

public val Res.string.change_password_button_title: StringResource by lazy {
      StringResource("string:change_password_button_title", "change_password_button_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1203, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1606, 56),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 1934, 72),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1203, 56),
      ))
    }

public val Res.string.change_password_question: StringResource by lazy {
      StringResource("string:change_password_question", "change_password_question", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1260, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1663, 56),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2007, 68),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1260, 56),
      ))
    }

public val Res.string.change_password_title: StringResource by lazy {
      StringResource("string:change_password_title", "change_password_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1317, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1720, 49),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2076, 61),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1317, 49),
      ))
    }

public val Res.string.clear_history: StringResource by lazy {
      StringResource("string:clear_history", "clear_history", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1441, 41),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2248, 65),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1441, 41),
      ))
    }

public val Res.string.clear_history_confirm: StringResource by lazy {
      StringResource("string:clear_history_confirm", "clear_history_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1367, 73),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2138, 109),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1367, 73),
      ))
    }

public val Res.string.comedy: StringResource by lazy {
      StringResource("string:comedy", "comedy", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1483, 22),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1770, 22),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2314, 34),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1483, 22),
      ))
    }

public val Res.string.continue_short: StringResource by lazy {
      StringResource("string:continue_short", "continue_short", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1506, 34),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2349, 50),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1506, 34),
      ))
    }

public val Res.string.continue_watching: StringResource by lazy {
      StringResource("string:continue_watching", "continue_watching", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1541, 49),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2400, 77),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1541, 49),
      ))
    }

public val Res.string.criminal: StringResource by lazy {
      StringResource("string:criminal", "criminal", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1591, 24),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1793, 24),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2478, 40),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1591, 24),
      ))
    }

public val Res.string.current_password_error: StringResource by lazy {
      StringResource("string:current_password_error", "current_password_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1616, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1818, 54),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2519, 102),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1616, 54),
      ))
    }

public val Res.string.current_password_hint: StringResource by lazy {
      StringResource("string:current_password_hint", "current_password_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1671, 61),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1873, 61),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2622, 85),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1671, 61),
      ))
    }

public val Res.string.current_password_label: StringResource by lazy {
      StringResource("string:current_password_label", "current_password_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1733, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 1935, 54),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2708, 66),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1733, 54),
      ))
    }

public val Res.string.decide_already_watched: StringResource by lazy {
      StringResource("string:decide_already_watched", "decide_already_watched", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1788, 46),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2775, 58),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1788, 46),
      ))
    }

public val Res.string.decide_another: StringResource by lazy {
      StringResource("string:decide_another", "decide_another", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1835, 38),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2834, 50),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1835, 38),
      ))
    }

public val Res.string.decide_banner_cta: StringResource by lazy {
      StringResource("string:decide_banner_cta", "decide_banner_cta", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1874, 37),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2885, 49),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1874, 37),
      ))
    }

public val Res.string.decide_banner_subtitle: StringResource by lazy {
      StringResource("string:decide_banner_subtitle", "decide_banner_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1912, 82),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 2935, 118),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1912, 82),
      ))
    }

public val Res.string.decide_banner_title: StringResource by lazy {
      StringResource("string:decide_banner_title", "decide_banner_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 1995, 51),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3054, 63),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 1995, 51),
      ))
    }

public val Res.string.decide_company_couple: StringResource by lazy {
      StringResource("string:decide_company_couple", "decide_company_couple", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2047, 37),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3118, 45),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2047, 37),
      ))
    }

public val Res.string.decide_company_family: StringResource by lazy {
      StringResource("string:decide_company_family", "decide_company_family", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2085, 37),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3164, 45),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2085, 37),
      ))
    }

public val Res.string.decide_company_group: StringResource by lazy {
      StringResource("string:decide_company_group", "decide_company_group", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2123, 44),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3210, 52),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2123, 44),
      ))
    }

public val Res.string.decide_company_hall: StringResource by lazy {
      StringResource("string:decide_company_hall", "decide_company_hall", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2168, 43),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3263, 47),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2168, 43),
      ))
    }

public val Res.string.decide_company_solo: StringResource by lazy {
      StringResource("string:decide_company_solo", "decide_company_solo", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2212, 39),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3311, 39),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2212, 39),
      ))
    }

public val Res.string.decide_company_title: StringResource by lazy {
      StringResource("string:decide_company_title", "decide_company_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2252, 52),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3351, 64),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2252, 52),
      ))
    }

public val Res.string.decide_company_trio: StringResource by lazy {
      StringResource("string:decide_company_trio", "decide_company_trio", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2305, 43),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3416, 43),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2305, 43),
      ))
    }

public val Res.string.decide_constraints_title: StringResource by lazy {
      StringResource("string:decide_constraints_title", "decide_constraints_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2349, 60),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3460, 76),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2349, 60),
      ))
    }

public val Res.string.decide_done: StringResource by lazy {
      StringResource("string:decide_done", "decide_done", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2410, 27),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3537, 35),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2410, 27),
      ))
    }

public val Res.string.decide_duration_long: StringResource by lazy {
      StringResource("string:decide_duration_long", "decide_duration_long", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2438, 52),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3573, 64),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2438, 52),
      ))
    }

public val Res.string.decide_duration_short: StringResource by lazy {
      StringResource("string:decide_duration_short", "decide_duration_short", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2491, 49),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3638, 49),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2491, 49),
      ))
    }

public val Res.string.decide_duration_standard: StringResource by lazy {
      StringResource("string:decide_duration_standard", "decide_duration_standard", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2541, 52),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3688, 72),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2541, 52),
      ))
    }

public val Res.string.decide_duration_title: StringResource by lazy {
      StringResource("string:decide_duration_title", "decide_duration_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2594, 65),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3761, 81),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2594, 65),
      ))
    }

public val Res.string.decide_edit_seeds: StringResource by lazy {
      StringResource("string:decide_edit_seeds", "decide_edit_seeds", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2660, 53),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3843, 81),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2660, 53),
      ))
    }

public val Res.string.decide_exclude_watched: StringResource by lazy {
      StringResource("string:decide_exclude_watched", "decide_exclude_watched", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2714, 46),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3925, 62),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2714, 46),
      ))
    }

public val Res.string.decide_exit_body: StringResource by lazy {
      StringResource("string:decide_exit_body", "decide_exit_body", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2761, 116),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 3988, 152),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2761, 116),
      ))
    }

public val Res.string.decide_exit_leave: StringResource by lazy {
      StringResource("string:decide_exit_leave", "decide_exit_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2878, 33),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 4141, 45),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2878, 33),
      ))
    }

public val Res.string.decide_exit_stay: StringResource by lazy {
      StringResource("string:decide_exit_stay", "decide_exit_stay", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2912, 32),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 4187, 48),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2912, 32),
      ))
    }

public val Res.string.decide_exit_title: StringResource by lazy {
      StringResource("string:decide_exit_title", "decide_exit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2945, 49),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 4236, 65),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2945, 49),
      ))
    }

public val Res.string.decide_high_rating: StringResource by lazy {
      StringResource("string:decide_high_rating", "decide_high_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 2995, 42),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 4302, 66),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 2995, 42),
      ))
    }

public val Res.string.decide_join_cta: StringResource by lazy {
      StringResource("string:decide_join_cta", "decide_join_cta", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3038, 43),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 4369, 51),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3038, 43),
      ))
    }

public val Res.string.decide_join_error: StringResource by lazy {
      StringResource("string:decide_join_error", "decide_join_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3082, 101),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 4421, 169),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3082, 101),
      ))
    }

public val Res.string.decide_join_hint: StringResource by lazy {
      StringResource("string:decide_join_hint", "decide_join_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3184, 88),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 4591, 104),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3184, 88),
      ))
    }

public val Res.string.decide_join_missing_body: StringResource by lazy {
      StringResource("string:decide_join_missing_body", "decide_join_missing_body", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3273, 168),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 4696, 240),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3273, 168),
      ))
    }

public val Res.string.decide_join_missing_code: StringResource by lazy {
      StringResource("string:decide_join_missing_code", "decide_join_missing_code", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3442, 48),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 4937, 48),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3442, 48),
      ))
    }

public val Res.string.decide_join_missing_title: StringResource by lazy {
      StringResource("string:decide_join_missing_title", "decide_join_missing_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3491, 69),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 4986, 73),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3491, 69),
      ))
    }

public val Res.string.decide_join_placeholder: StringResource by lazy {
      StringResource("string:decide_join_placeholder", "decide_join_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3561, 39),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5060, 39),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3561, 39),
      ))
    }

public val Res.string.decide_join_start_own: StringResource by lazy {
      StringResource("string:decide_join_start_own", "decide_join_start_own", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3601, 53),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5100, 77),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3601, 53),
      ))
    }

public val Res.string.decide_join_title: StringResource by lazy {
      StringResource("string:decide_join_title", "decide_join_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3655, 49),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5178, 61),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3655, 49),
      ))
    }

public val Res.string.decide_mood_funny: StringResource by lazy {
      StringResource("string:decide_mood_funny", "decide_mood_funny", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3705, 33),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5240, 45),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3705, 33),
      ))
    }

public val Res.string.decide_mood_light: StringResource by lazy {
      StringResource("string:decide_mood_light", "decide_mood_light", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3739, 33),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5286, 41),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3739, 33),
      ))
    }

public val Res.string.decide_mood_surprise: StringResource by lazy {
      StringResource("string:decide_mood_surprise", "decide_mood_surprise", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3773, 44),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5328, 56),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3773, 44),
      ))
    }

public val Res.string.decide_mood_tense: StringResource by lazy {
      StringResource("string:decide_mood_tense", "decide_mood_tense", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3818, 33),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5385, 57),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3818, 33),
      ))
    }

public val Res.string.decide_mood_title: StringResource by lazy {
      StringResource("string:decide_mood_title", "decide_mood_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3852, 41),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5443, 69),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3852, 41),
      ))
    }

public val Res.string.decide_next: StringResource by lazy {
      StringResource("string:decide_next", "decide_next", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3894, 27),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5513, 35),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3894, 27),
      ))
    }

public val Res.string.decide_no_subtitles: StringResource by lazy {
      StringResource("string:decide_no_subtitles", "decide_no_subtitles", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3922, 43),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5549, 63),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3922, 43),
      ))
    }

public val Res.string.decide_not_for_me: StringResource by lazy {
      StringResource("string:decide_not_for_me", "decide_not_for_me", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 3966, 41),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5613, 53),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 3966, 41),
      ))
    }

public val Res.string.decide_party_code_hint: StringResource by lazy {
      StringResource("string:decide_party_code_hint", "decide_party_code_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4008, 138),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5667, 222),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4008, 138),
      ))
    }

public val Res.string.decide_party_copied: StringResource by lazy {
      StringResource("string:decide_party_copied", "decide_party_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4147, 43),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5890, 75),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4147, 43),
      ))
    }

public val Res.string.decide_party_copy: StringResource by lazy {
      StringResource("string:decide_party_copy", "decide_party_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4191, 37),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 5966, 73),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4191, 37),
      ))
    }

public val Res.string.decide_party_host: StringResource by lazy {
      StringResource("string:decide_party_host", "decide_party_host", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4229, 33),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6040, 37),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4229, 33),
      ))
    }

public val Res.string.decide_party_limit: StringResource by lazy {
      StringResource("string:decide_party_limit", "decide_party_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4352, 42),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6179, 62),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4352, 42),
      ))
    }

public val Res.string.decide_party_limit_n: StringResource by lazy {
      StringResource("string:decide_party_limit_n", "decide_party_limit_n", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4307, 44),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6138, 40),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4307, 44),
      ))
    }

public val Res.string.decide_party_limit_none: StringResource by lazy {
      StringResource("string:decide_party_limit_none", "decide_party_limit_none", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4263, 43),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6078, 59),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4263, 43),
      ))
    }

public val Res.string.decide_party_lock: StringResource by lazy {
      StringResource("string:decide_party_lock", "decide_party_lock", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4467, 45),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6334, 61),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4467, 45),
      ))
    }

public val Res.string.decide_party_locked: StringResource by lazy {
      StringResource("string:decide_party_locked", "decide_party_locked", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4395, 71),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6242, 91),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4395, 71),
      ))
    }

public val Res.string.decide_party_pick_now: StringResource by lazy {
      StringResource("string:decide_party_pick_now", "decide_party_pick_now", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4513, 53),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6396, 65),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4513, 53),
      ))
    }

public val Res.string.decide_party_ready: StringResource by lazy {
      StringResource("string:decide_party_ready", "decide_party_ready", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4567, 34),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6462, 42),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4567, 34),
      ))
    }

public val Res.string.decide_party_slots: StringResource by lazy {
      StringResource("string:decide_party_slots", "decide_party_slots", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4658, 58),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6561, 62),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4658, 58),
      ))
    }

public val Res.string.decide_party_slots_open: StringResource by lazy {
      StringResource("string:decide_party_slots_open", "decide_party_slots_open", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4602, 55),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6505, 55),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4602, 55),
      ))
    }

public val Res.string.decide_party_title: StringResource by lazy {
      StringResource("string:decide_party_title", "decide_party_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4717, 42),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6624, 46),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4717, 42),
      ))
    }

public val Res.string.decide_party_votes: StringResource by lazy {
      StringResource("string:decide_party_votes", "decide_party_votes", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4760, 70),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6671, 86),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4760, 70),
      ))
    }

public val Res.string.decide_party_wait_host: StringResource by lazy {
      StringResource("string:decide_party_wait_host", "decide_party_wait_host", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4831, 70),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6758, 82),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4831, 70),
      ))
    }

public val Res.string.decide_party_waiting: StringResource by lazy {
      StringResource("string:decide_party_waiting", "decide_party_waiting", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 4902, 132),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 6841, 184),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 4902, 132),
      ))
    }

public val Res.string.decide_party_you: StringResource by lazy {
      StringResource("string:decide_party_you", "decide_party_you", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5035, 28),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 7026, 32),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5035, 28),
      ))
    }

public val Res.string.decide_pick_empty: StringResource by lazy {
      StringResource("string:decide_pick_empty", "decide_pick_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5064, 149),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 7059, 341),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5064, 149),
      ))
    }

public val Res.string.decide_preferences_title: StringResource by lazy {
      StringResource("string:decide_preferences_title", "decide_preferences_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5214, 52),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 7401, 56),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5214, 52),
      ))
    }

public val Res.string.decide_ready_body: StringResource by lazy {
      StringResource("string:decide_ready_body", "decide_ready_body", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5267, 145),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 7458, 233),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5267, 145),
      ))
    }

public val Res.string.decide_ready_title: StringResource by lazy {
      StringResource("string:decide_ready_title", "decide_ready_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5413, 70),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 7692, 98),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5413, 70),
      ))
    }

public val Res.string.decide_reason_family: StringResource by lazy {
      StringResource("string:decide_reason_family", "decide_reason_family", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5484, 52),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 7791, 80),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5484, 52),
      ))
    }

public val Res.string.decide_reason_from_taste: StringResource by lazy {
      StringResource("string:decide_reason_from_taste", "decide_reason_from_taste", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5537, 72),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 7872, 96),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5537, 72),
      ))
    }

public val Res.string.decide_reason_high_rating: StringResource by lazy {
      StringResource("string:decide_reason_high_rating", "decide_reason_high_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5610, 69),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 7969, 117),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5610, 69),
      ))
    }

public val Res.string.decide_reason_mood: StringResource by lazy {
      StringResource("string:decide_reason_mood", "decide_reason_mood", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5680, 50),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 8087, 74),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5680, 50),
      ))
    }

public val Res.string.decide_reason_popular: StringResource by lazy {
      StringResource("string:decide_reason_popular", "decide_reason_popular", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5731, 61),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 8162, 89),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5731, 61),
      ))
    }

public val Res.string.decide_reason_similar: StringResource by lazy {
      StringResource("string:decide_reason_similar", "decide_reason_similar", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5793, 69),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 8252, 65),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5793, 69),
      ))
    }

public val Res.string.decide_reason_surprise: StringResource by lazy {
      StringResource("string:decide_reason_surprise", "decide_reason_surprise", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5863, 62),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 8318, 94),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5863, 62),
      ))
    }

public val Res.string.decide_reason_time: StringResource by lazy {
      StringResource("string:decide_reason_time", "decide_reason_time", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5926, 58),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 8413, 90),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5926, 58),
      ))
    }

public val Res.string.decide_reason_together: StringResource by lazy {
      StringResource("string:decide_reason_together", "decide_reason_together", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 5985, 86),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 8504, 106),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 5985, 86),
      ))
    }

public val Res.string.decide_seeds_count: StringResource by lazy {
      StringResource("string:decide_seeds_count", "decide_seeds_count", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 6072, 62),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 8611, 78),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 6072, 62),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("about", Res.string.about)
  map.put("about_crawl_body", Res.string.about_crawl_body)
  map.put("about_crawl_episode", Res.string.about_crawl_episode)
  map.put("about_crawl_prologue", Res.string.about_crawl_prologue)
  map.put("about_crawl_title", Res.string.about_crawl_title)
  map.put("about_text", Res.string.about_text)
  map.put("action", Res.string.action)
  map.put("adventures", Res.string.adventures)
  map.put("app_copyright", Res.string.app_copyright)
  map.put("app_name", Res.string.app_name)
  map.put("app_version", Res.string.app_version)
  map.put("ask_questions", Res.string.ask_questions)
  map.put("biografy", Res.string.biografy)
  map.put("cartoons", Res.string.cartoons)
  map.put("change_password_button_title", Res.string.change_password_button_title)
  map.put("change_password_question", Res.string.change_password_question)
  map.put("change_password_title", Res.string.change_password_title)
  map.put("clear_history", Res.string.clear_history)
  map.put("clear_history_confirm", Res.string.clear_history_confirm)
  map.put("comedy", Res.string.comedy)
  map.put("continue_short", Res.string.continue_short)
  map.put("continue_watching", Res.string.continue_watching)
  map.put("criminal", Res.string.criminal)
  map.put("current_password_error", Res.string.current_password_error)
  map.put("current_password_hint", Res.string.current_password_hint)
  map.put("current_password_label", Res.string.current_password_label)
  map.put("decide_already_watched", Res.string.decide_already_watched)
  map.put("decide_another", Res.string.decide_another)
  map.put("decide_banner_cta", Res.string.decide_banner_cta)
  map.put("decide_banner_subtitle", Res.string.decide_banner_subtitle)
  map.put("decide_banner_title", Res.string.decide_banner_title)
  map.put("decide_company_couple", Res.string.decide_company_couple)
  map.put("decide_company_family", Res.string.decide_company_family)
  map.put("decide_company_group", Res.string.decide_company_group)
  map.put("decide_company_hall", Res.string.decide_company_hall)
  map.put("decide_company_solo", Res.string.decide_company_solo)
  map.put("decide_company_title", Res.string.decide_company_title)
  map.put("decide_company_trio", Res.string.decide_company_trio)
  map.put("decide_constraints_title", Res.string.decide_constraints_title)
  map.put("decide_done", Res.string.decide_done)
  map.put("decide_duration_long", Res.string.decide_duration_long)
  map.put("decide_duration_short", Res.string.decide_duration_short)
  map.put("decide_duration_standard", Res.string.decide_duration_standard)
  map.put("decide_duration_title", Res.string.decide_duration_title)
  map.put("decide_edit_seeds", Res.string.decide_edit_seeds)
  map.put("decide_exclude_watched", Res.string.decide_exclude_watched)
  map.put("decide_exit_body", Res.string.decide_exit_body)
  map.put("decide_exit_leave", Res.string.decide_exit_leave)
  map.put("decide_exit_stay", Res.string.decide_exit_stay)
  map.put("decide_exit_title", Res.string.decide_exit_title)
  map.put("decide_high_rating", Res.string.decide_high_rating)
  map.put("decide_join_cta", Res.string.decide_join_cta)
  map.put("decide_join_error", Res.string.decide_join_error)
  map.put("decide_join_hint", Res.string.decide_join_hint)
  map.put("decide_join_missing_body", Res.string.decide_join_missing_body)
  map.put("decide_join_missing_code", Res.string.decide_join_missing_code)
  map.put("decide_join_missing_title", Res.string.decide_join_missing_title)
  map.put("decide_join_placeholder", Res.string.decide_join_placeholder)
  map.put("decide_join_start_own", Res.string.decide_join_start_own)
  map.put("decide_join_title", Res.string.decide_join_title)
  map.put("decide_mood_funny", Res.string.decide_mood_funny)
  map.put("decide_mood_light", Res.string.decide_mood_light)
  map.put("decide_mood_surprise", Res.string.decide_mood_surprise)
  map.put("decide_mood_tense", Res.string.decide_mood_tense)
  map.put("decide_mood_title", Res.string.decide_mood_title)
  map.put("decide_next", Res.string.decide_next)
  map.put("decide_no_subtitles", Res.string.decide_no_subtitles)
  map.put("decide_not_for_me", Res.string.decide_not_for_me)
  map.put("decide_party_code_hint", Res.string.decide_party_code_hint)
  map.put("decide_party_copied", Res.string.decide_party_copied)
  map.put("decide_party_copy", Res.string.decide_party_copy)
  map.put("decide_party_host", Res.string.decide_party_host)
  map.put("decide_party_limit", Res.string.decide_party_limit)
  map.put("decide_party_limit_n", Res.string.decide_party_limit_n)
  map.put("decide_party_limit_none", Res.string.decide_party_limit_none)
  map.put("decide_party_lock", Res.string.decide_party_lock)
  map.put("decide_party_locked", Res.string.decide_party_locked)
  map.put("decide_party_pick_now", Res.string.decide_party_pick_now)
  map.put("decide_party_ready", Res.string.decide_party_ready)
  map.put("decide_party_slots", Res.string.decide_party_slots)
  map.put("decide_party_slots_open", Res.string.decide_party_slots_open)
  map.put("decide_party_title", Res.string.decide_party_title)
  map.put("decide_party_votes", Res.string.decide_party_votes)
  map.put("decide_party_wait_host", Res.string.decide_party_wait_host)
  map.put("decide_party_waiting", Res.string.decide_party_waiting)
  map.put("decide_party_you", Res.string.decide_party_you)
  map.put("decide_pick_empty", Res.string.decide_pick_empty)
  map.put("decide_preferences_title", Res.string.decide_preferences_title)
  map.put("decide_ready_body", Res.string.decide_ready_body)
  map.put("decide_ready_title", Res.string.decide_ready_title)
  map.put("decide_reason_family", Res.string.decide_reason_family)
  map.put("decide_reason_from_taste", Res.string.decide_reason_from_taste)
  map.put("decide_reason_high_rating", Res.string.decide_reason_high_rating)
  map.put("decide_reason_mood", Res.string.decide_reason_mood)
  map.put("decide_reason_popular", Res.string.decide_reason_popular)
  map.put("decide_reason_similar", Res.string.decide_reason_similar)
  map.put("decide_reason_surprise", Res.string.decide_reason_surprise)
  map.put("decide_reason_time", Res.string.decide_reason_time)
  map.put("decide_reason_together", Res.string.decide_reason_together)
  map.put("decide_seeds_count", Res.string.decide_seeds_count)
}
